import React, { useEffect, useState } from "react";
import { useLocation, useParams, useRouteMatch } from "react-router-dom";
import { inject } from "mobx-react";
import FILTER_TYPES from "./FILTER_TYPES";
import { useGetMobileTagsQuery } from "routes/operator/routes/hooks";
import Row from "reactstrap/lib/Row";
import Container from "reactstrap/lib/Container";
import { OPERATOR_TAB_ACTIONS } from "stores/OperatorModel";
// import { useGetNewsQuery, usePathnameWithoutPage } from "./Actions.hooks";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import TagButtonComponent from "Containers/TagButtonComponent";
// import Block from "ComponentsUI/Block";
// import { NewsLayout } from "ComponentsUI/News";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import MobileTariffList from "ComponentsUI/MobileTariffList";
// import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import { useFiltersTariffs } from "../hooks";
import { ResetFiltersBlock } from "designSystem/EmptyContentBlocks/ResetFiltersBlock/ResetFiltersBlock";
import TariffsFilterContainer from "../ratesMobile/Containers/TariffsFilterContainer";
import { createUseStyles } from "react-jss";
import { isMainSiteCode } from "Utils/siteConfig";

const useStyles = createUseStyles((theme) => ({
	[`@media (min-width: ${theme.media.md})`]: {
		container: {
			marginTop: "50px",
		},
	},
}));

// const LIMIT = 30;
const MINUTES_RANGE_STEP = 10;

const Actions = (props) => {
	const {
		operatorForCard: {
			info: { cnt_action_tariffs },
			// id,
		},
		ApplicationModel: { text, windowSizeModel, operatorModel, mobileFiltersTouchModel },
	} = props;
	const siteCode = props.ApplicationModel.siteCode;
	const classes = useStyles();

	const location = useLocation();
	const params = useParams();

	const {
		tariffs,
		//fetchMoreTariffs,
		//totalTariffs,
		currentOperator,
		//isTariffsLoading,
		resetFilters,
		setFilters,
		// isLoading,
		initalFilters,
		currentFilters,
	} = useFiltersTariffs(location.search, true);

	const [filtersItems, setFiltersItems] = useState(null);
	const selected = filtersItems ? filtersItems.filter((item) => item.props.value) : [];

	useEffect(() => {
		if (operatorModel.visibleTab !== OPERATOR_TAB_ACTIONS) {
			operatorModel.changeTab(OPERATOR_TAB_ACTIONS);
		}
	}, []);

	useEffect(() => {
		if (!initalFilters) {
			return;
		}

		setFiltersItems([
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.minutes,
					title: text.MINUTES,
					value: currentFilters.minutes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							minutes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							minutes: null,
						});
					},
					step: MINUTES_RANGE_STEP,
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_minutes_min",
					inputNameMax: "change_minutes_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.gigabytes,
					title: text.INTERNET,
					value: currentFilters.gigabytes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							gigabytes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							gigabytes: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_gb_min",
					inputNameMax: "change_gb_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.price,
					title: text.SUBSCRIPTION_FEE,
					value: currentFilters.price,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							price: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							price: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_price_min",
					inputNameMax: "change_price_max",
				},
			},
		]);
	}, [
		currentFilters.gigabytes,
		currentFilters.minutes,
		currentFilters.price,
		initalFilters,
		setFilters,
		text,
		currentOperator,
		mobileFiltersTouchModel,
	]);

	// const pathname = usePathnameWithoutPage();
	const routeMach = useRouteMatch();

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_ACTIONS_OPERATORY, []);
	}, [routeMach.path]);

	// const { news, isLoading, pagination } = useGetNewsQuery(id);
	const { mobileTags } = useGetMobileTagsQuery(!cnt_action_tariffs);

	// let pageTotal = 0;
	// let page = 1;
	// if (pagination) {
	//     pageTotal = Math.ceil(pagination.items_total / LIMIT);
	//     if (params.page) {
	//         page = +params.page;
	//     }
	// }

	return (
		<PaddingTop containerClass={classes.container}>
			<PaddingBottom>
				{filtersItems && (
					<TariffsFilterContainer filters={filtersItems} onMobileResetButtonClick={resetFilters} />
				)}
				{isMainSiteCode(siteCode) && <div></div>}
				<Container>
					{tariffs.length ? (
						<PaddingTop>
							<TagButtonComponent
								mobileTags={mobileTags}
								text={text}
								tagCode={true}
								operatorRates={true}
								operatorStyle={true}
							/>
							<Row>
								<MobileTariffList tariffs={tariffs} text={text} isAction={true} />
							</Row>
						</PaddingTop>
					) : null}
					{!tariffs.length && selected.length ? (
						<ResetFiltersBlock text={text} onResetClick={resetFilters} />
					) : null}

					{/*{news && (*/}
					{/*    <PaddingTop>*/}
					{/*        <Block*/}
					{/*            header={text.actions}*/}
					{/*            headerWithoutMargin={true}*/}
					{/*        >*/}
					{/*            <NewsLayout*/}
					{/*                stub={isLoading}*/}
					{/*                items={news}*/}
					{/*                containerClassName="Block__wrapper container"*/}
					{/*            />*/}
					{/*        </Block>*/}
					{/*    </PaddingTop>*/}
					{/*)}*/}

					{/*{pagination && (*/}
					{/*    <div style={{ paddingTop: "15px" }}>*/}
					{/*        <Paginator*/}
					{/*            key={23}*/}
					{/*            itemsTotal={pagination.items_total}*/}
					{/*            itemsPerPage={LIMIT}*/}
					{/*            pageCurrent={page}*/}
					{/*            pageTotal={pageTotal}*/}
					{/*            windowSizes={windowSizeModel.windowSizes}*/}
					{/*            urlDefault={pathname}*/}
					{/*            wrapperItem={<PaginatorElem />}*/}
					{/*            location={location}*/}
					{/*        />*/}
					{/*    </div>*/}
					{/*)}*/}
				</Container>
			</PaddingBottom>
		</PaddingTop>
	);
};

export default inject("ApplicationModel")(Actions);
